import { Colors } from "../../../../styles/theme";

const styles = {
  ListLanguageButton_button: {
    direction: "ltr",
    fontWeight: 700,
    fontSize: { xs: "1rem", sm: "1.125rem" },
    letterSpacing: 0,
    px: { xs: 1.75, sm: 3 },
    py: 1,
    border: 0,
    backgroundColor: "transparent",
    "&:hover": {
      backgroundColor: "transparent",
    },
    "& .MuiButton-startIcon": {
      marginRight: 0.5,
      "& .MuiSvgIcon-root": {
        fontSize: { xs: 28, sm: 30 },
      },
    },
    "& .MuiButton-endIcon": {
      marginLeft: 0.25,
    },
  },
  ListLanguageButton_menuContainer: {
    display: { xs: "block" },
    mt: 0.75,
    "& .MuiPaper-root": {
      minWidth: { xs: 200, sm: 224 },
      border: "1px solid #E4EBF4",
      borderRadius: "8px",
      boxShadow: "0 10px 28px rgba(34, 49, 78, 0.14)",
      overflow: "hidden",
    },
    "& .MuiList-root": {
      padding: 1,
    },
  },
  ListLanguageButton_menuItem: {
    width: "100%",
    minHeight: 52,
    justifyContent: "space-between",
    gap: 2,
    color: Colors.navy,
    borderRadius: "6px",
    px: 2,
    fontSize: "1rem",
    letterSpacing: 0,
    "&.Mui-selected": {
      color: Colors.primary,
      backgroundColor: "#EEF5FD",
    },
    "&.Mui-selected:hover": {
      backgroundColor: "#E7F0FB",
    },
  },
};
export default styles;
